"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var merge_styles_1 = require("@uifabric/merge-styles");
exports.commandBarClassNames = function (compact) { return merge_styles_1.mergeStyleSets({
    root: [compact && {
            selectors: {
                '& .ms-CommandBar-primaryCommands': {
                    margin: 0
                },
                '& .ms-CommandBar-primaryCommands .ms-CommandBarItem-icon': {
                    fontSize: 12
                },
                '& .ms-CommandBar-primaryCommands .ms-CommandBarItem-commandText': {
                    fontSize: 12
                },
                '& .ms-CommandBar-primaryCommands .ms-CommandBarItem-link': {
                    fontSize: 12
                }
            }
        }]
}); };
//# sourceMappingURL=commandBar.js.map